import { forwardRef, HTMLAttributes } from "react";
import type { TellescopeFormFieldBaseProps } from "../../types";
import { cn } from "@tellescope/utils";
import { Button } from "@tellescope/ui";
import { useTranslation } from "react-i18next";
import { EMPTY_BELUGA_MEDICATION } from "./constants";
import { BelugaPatientPreferenceMedication } from "./BelugaPatientPreferenceMedication";

export interface BelugaPatientPreferenceFieldProps
  extends TellescopeFormFieldBaseProps<"Beluga Patient Preference">,
    Omit<HTMLAttributes<HTMLDivElement>, keyof TellescopeFormFieldBaseProps<"Beluga Patient Preference">> {}

export const BelugaPatientPreferenceField = forwardRef<HTMLDivElement, BelugaPatientPreferenceFieldProps>(
  ({ type: _, title, value, onChange, className, onBlur, error, ...rest }, ref) => {
    const { t } = useTranslation("forms");
    return (
      <div className={cn("flex flex-col gap-2", className)} {...rest} ref={ref}>
        {!!title && <h4>{title}</h4>}
        {value?.map((medication, i) => (
          <BelugaPatientPreferenceMedication
            key={medication.medId}
            value={medication}
            onChange={(newVal) => {
              onChange(value.map((item, j) => (i === j ? newVal : item)));
            }}
            onRemove={() => {
              onChange([...value.slice(0, i), ...value.slice(i + 1)]);
            }}
            onBlur={onBlur}
          />
        ))}
        <div className={`flex ${value?.length ? "justify-end" : ""}`}>
          <Button
            variant="outline"
            onClick={() => {
              onChange([...(value ?? []), EMPTY_BELUGA_MEDICATION]);
            }}
          >
            {t("Add Medication")}
          </Button>
        </div>
        {!!error && <p className="text-sm text-destructive mt-1">{error}</p>}
      </div>
    );
  }
);
